import { AttachmentRule, Behavior } from "./types";

export class ObjectPickupBehavior extends Behavior {
  private timeAttached: number = 0;
  private hasTriggered: boolean = false;
  private triggerDelay: number = 5000; // 5 seconds in milliseconds
  private cubeColor: string = "#00FF00"; // Default green color
  private cubeSize: number = 0.5; // Default cube size

  static getAttachmentRules(): AttachmentRule[] {
    return [{ type: "class", selector: "object-pickup" }];
  }

  onAttach(): void {
    console.log("ObjectPickupBehavior attached to:", this.element);

    // Read cube configuration from element attributes
    const colorAttr = this.element.getAttribute("cube-color");
    if (colorAttr) {
      this.cubeColor = colorAttr;
    }

    const sizeAttr = this.element.getAttribute("cube-size");
    if (sizeAttr) {
      const size = parseFloat(sizeAttr);
      if (!isNaN(size) && size > 0) {
        this.cubeSize = size;
      }
    }

    console.log(
      `ObjectPickupBehavior: Will add ${this.cubeColor} cubes to all characters in 5 seconds`,
    );
  }

  onDetach(): void {
    console.log("ObjectPickupBehavior detached from:", this.element);
  }

  tick(deltaTime: number): void {
    if (this.hasTriggered) {
      return; // Already triggered, nothing to do
    }

    // Accumulate time
    this.timeAttached += deltaTime * 1000; // deltaTime is in seconds, convert to ms

    // Check if 5 seconds have passed
    if (this.timeAttached >= this.triggerDelay) {
      this.addCubesToAllCharacters();
      this.hasTriggered = true;
    }
  }

  private addCubesToAllCharacters(): void {
    console.log("ObjectPickupBehavior: Adding cubes to all characters in the scene");

    // Find all m-character elements in the scene
    const rootElement = this.getRootElement();
    if (!rootElement) {
      console.log("ObjectPickupBehavior: Could not find root element");
      return;
    }

    const characters = Array.from(rootElement.querySelectorAll("m-character"));
    console.log(`ObjectPickupBehavior: Found ${characters.length} characters in scene`);

    // Add a cube to each character's head
    characters.forEach((character, index) => {
      const cube = document.createElement("m-cube");

      // Configure the cube
      cube.setAttribute("color", this.cubeColor);
      cube.setAttribute("width", this.cubeSize.toString());
      cube.setAttribute("height", this.cubeSize.toString());
      cube.setAttribute("depth", this.cubeSize.toString());

      // Position the cube at the head socket
      cube.setAttribute("socket", "head");

      // Add visual flair
      cube.setAttribute("class", "pickup-cube color-cycle");

      // Prevent the cube from interfering with physics
      cube.setAttribute("collide", "false");

      // Mount the cube to the character
      character.appendChild(cube);

      console.log(`ObjectPickupBehavior: Added cube to character ${index + 1}`);
    });

    // Mark this element as used by graying it out
    this.element.setAttribute("color", "#888888");
    this.element.setAttribute("opacity", "0.3");

    console.log(
      `ObjectPickupBehavior: Successfully added cubes to ${characters.length} characters`,
    );

    // Dispatch a custom event
    const pickupEvent = new CustomEvent("object-picked-up", {
      detail: {
        pickup: this.element,
        charactersAffected: characters.length,
      },
    });
    this.element.dispatchEvent(pickupEvent);
  }
}
